
export function SiteFooter() {
  return (
    <footer className="relative h-[200px] sm:h-[225px] md:h-[300px] flex items-center overflow-hidden bg-[#4a1811] text-[#efebe4] border-t-4 border-[#d8b248]/30">
      {/* Background Marquee Animation */}
      <div className="absolute inset-0 z-0 flex items-center opacity-30 pointer-events-none select-none">
        <div className="flex shrink-0 h-full w-auto animate-[marquee_160s_linear_infinite]">
          {[...Array(8)].map((_, i) => (
            <img 
              key={i}
              src="/images/photoboothanimation.png" 
              alt="Photobooth Animation" 
              className="h-full w-auto object-contain shrink-0 mx-4 opacity-80 mix-blend-screen" 
              loading="lazy"
            />
          ))}
        </div>
        <div className="flex shrink-0 h-full w-auto animate-[marquee_160s_linear_infinite]" aria-hidden="true">
          {[...Array(8)].map((_, i) => (
            <img 
              key={`dup-${i}`}
              src="/images/photoboothanimation.png" 
              alt="Photobooth Animation" 
              className="h-full w-auto object-contain shrink-0 mx-4 opacity-80 mix-blend-screen" 
              loading="lazy"
            />
          ))}
        </div>
      </div>

      <style>{`
        @keyframes marquee {
          0% { transform: translateX(0%); }
          100% { transform: translateX(-100%); }
        }
      `}</style>
      
      {/* Foreground Text */}
      <div className="relative z-10 shell flex flex-col items-center text-center space-y-1 md:space-y-2">
        <h2 
          className="font-display text-xl sm:text-2xl md:text-3xl text-[#eed8a1] tracking-[0.15em] uppercase" 
          style={{ fontFamily: 'CN Motel, sans-serif' }}
        >
          Fairytale of Albacete
        </h2>
        
        <p 
          className="font-serif text-lg sm:text-xl md:text-2xl text-white" 
          style={{ fontFamily: 'Morello, serif' }}
          translate="no"
        >
          by Lucia & John
        </p>
        
        <div className="w-12 sm:w-16 h-px bg-[#d8b248]/40 my-1 sm:my-2"></div>
        
        <p 
          className="font-sans text-xs sm:text-sm md:text-base text-[#eed8a1]/80 max-w-lg mx-auto leading-relaxed tracking-wide italic" 
          style={{ fontFamily: 'Prestige, sans-serif' }}
          translate="no"
        >
          Built with ❤️, patience, and not one single argument, 2026
        </p>
      </div>
    </footer>
  )
}
